export const matchesUrl = (urlFilter: string, url: string) => new RegExp(`${urlFilter.replace(/\*/g, '.*')}$`).test(url)
